// @ts-nocheck
import { normalText } from 'assets/colors/colors';

export function createMaterialPaginationStyles() {
  return {
    MuiTableFooter: {
      styleOverrides: {
        root: {
          display: 'block',
          borderTop: '1px solid #EEEEEE',

          '& .MuiAlert-root': {
            backgroundColor: 'transparent',

            '& .MuiButton-root': {
              padding: '5px 10px',
            },
          },

          '& .MuiStack-root ': {
            padding: '0',
          },

          '& .MuiAlert-message': {
            fontSize: '14px!important',
          },

          '& .MuiCollapse-wrapper': {
            paddingLeft: '15px',
            paddingTop: '8',
          },

          '& .MuiMenuItem-root': {
            fontSize: '12px',
            justifyContent: 'center',
            padding: '3px 5px',
          },

          '.MuiTablePagination-root': {
            color: normalText.dark,

            '& .MuiFormLabel-root': {
              color: normalText.dark,
            },

            '& .MuiSvgIcon-root': {
              color: normalText.dark,
            },

            '& .Mui-disabled ': {
              '& .MuiSvgIcon-root': {
                color: normalText.lightGrey,
              },
            },

            '& .MuiSelect-standard.MuiSelect-select ': {
              paddingRight: '20px!important',
              minWidth: '25px',
              color: normalText.main,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          },
        },
      },
    },
  };
}
